import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const PromoReel = () => {
	const block = document.querySelectorAll(".promo-reel");
	if (!block) {
		return;
	}
	gsap.registerPlugin(ScrollTrigger);
	let mm = gsap.matchMedia();
	const audios = document.querySelectorAll("audio");

	if (!window.YT) {
		const tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		const firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	block.forEach((element) => {
		const video = element.querySelector("video");
		const youtubeContainer = element.querySelector(".promo-reel__youtube");
		const control = element.querySelector(".promo-reel__control");
		let player = null;
		let isMuted = true;
		let isActive = false;
		const togglePlay = element.classList.contains("promo-reel_toggle-play");

		if (youtubeContainer) {
			const iframe = youtubeContainer.querySelector("iframe");
			if (iframe) {
				const src = iframe.src;
				const videoIdMatch = src.match(/[?&]v=([^&]+)/) || src.match(/embed\/([^?]+)/);
				const videoId = videoIdMatch ? videoIdMatch[1] : null;

				if (videoId) {
					element.classList.add("promo-reel_youtube");
					
					const newIframe = document.createElement('iframe');
					newIframe.width = '100%';
					newIframe.height = '100%';
					newIframe.frameBorder = '0';
					newIframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
					newIframe.allowFullscreen = true;
					newIframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=0&mute=1&loop=1&playlist=${videoId}&rel=0&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}`;

					iframe.parentNode.replaceChild(newIframe, iframe);

					window.onYouTubeIframeAPIReady = function() {
						player = new YT.Player(newIframe, {
							events: {
								'onReady': function(event) {
									event.target.mute();
									isMuted = true;
									control.classList.remove("active");
								}
							}
						});
					};

					if (window.YT && window.YT.Player) {
						player = new YT.Player(newIframe, {
							events: {
								'onReady': function(event) {
									event.target.mute();
									isMuted = true;
									control.classList.remove("active");
								}
							}
						});
					}
				}
			}
		}

		const playVideo = () => {
			if (video) {
				video.play();
				video.classList.add("playing");
			}
			if (player && player.playVideo && typeof player.playVideo === 'function') {
				player.playVideo();
			}
		};

		const playVideoToggle = () => {
			if (video) {
				video.play();
				video.classList.add("playing");
			}
			if (player && player.playVideo && typeof player.playVideo === 'function') {
				player.playVideo();
			}
		};

		const pauseVideo = () => {
			if (video && video.classList.contains("playing")) {
				video.pause();
				video.setAttribute("muted", "muted");
				video.muted = true;
				video.classList.remove("playing");
				control.classList.remove("active");
			}
			if (player && player.pauseVideo && typeof player.pauseVideo === 'function') {
				player.pauseVideo();
			}
		};

		const pauseVideoToggle = () => {
			if (video && video.classList.contains("playing")) {
				video.pause();
				video.classList.remove("playing");
			}
			if (player && player.pauseVideo && typeof player.pauseVideo === 'function') {
				player.pauseVideo();
			}
		};

		// set pause if not in viewbox
		if (!togglePlay) {
			gsap.timeline({
				scrollTrigger: {
					trigger: element,
					start: "top bottom",
					scrub: true,
					onEnter: () => {
						playVideo();
					},
					onEnterBack: () => {
						playVideo();
					},
					onLeave: () => {
						pauseVideo();
					},
					onLeaveBack: () => {
						pauseVideo();
					}
				}
			});
		} else {
			if (video) {
				video.addEventListener('loadedmetadata', () => {
					video.play();
					video.classList.add("playing");
				});
			}
		}

		const toggleControl = () => {
			if (!isActive) {
				element.classList.add("active");
				isActive = true;
			}

			if (togglePlay) {
				if (video) {
					if (video.classList.contains("playing")) {
						pauseVideoToggle();
					} else {
						playVideoToggle();
						video.removeAttribute("muted");
						video.muted = false;
						control.classList.add("active");
						
						audios.forEach(audio => {
							audio.pause();
						});
					}
				}
				
				if (player) {
					if (player.getPlayerState && typeof player.getPlayerState === 'function') {
						const state = player.getPlayerState();
						if (state === 1) {
							player.pauseVideo();
						} else {
							player.playVideo();
							if (player.unMute && typeof player.unMute === 'function') {
								player.unMute();
								isMuted = false;
								control.classList.add("active");
								
								audios.forEach(audio => {
									audio.pause();
								});
							}
						}
					}
				}
			} else {
				if (video) {
					if (video.getAttribute("muted") === "muted") {
						video.removeAttribute("muted");
						video.muted = false;
						control.classList.add("active");

						audios.forEach(audio => {
							audio.pause();
						});
					} else {
						video.setAttribute("muted", "muted");
						video.muted = true;
						control.classList.remove("active");
					}
				}
				
				if (player && player.unMute && player.mute) {
					if (isMuted) {
						player.unMute();
						isMuted = false;
						control.classList.add("active");
						
						audios.forEach(audio => {
							audio.pause();
						});
					} else {
						player.mute();
						isMuted = true;
						control.classList.remove("active");
					}
				}
			}
		};

		mm.add("(max-width: 1023px)", () => {
			control.addEventListener("click", (e) => {
				toggleControl();
			});
		});

		mm.add("(min-width: 1024px)", () => {
			const moveCursor = function (event) {
				gsap.to(control, {
					css: {
						left: event.pageX - element.offsetLeft,
						top: event.pageY - element.offsetTop
					},
					duration: 0.4
				});
			};

			element.addEventListener("mouseover", (e) => {
				document.addEventListener("mousemove", moveCursor, false);
			});

			element.addEventListener("mouseleave", (e) => {
				document.removeEventListener("mousemove", moveCursor, false);
				gsap.to(control, { css: { left: "50%", top: "50%" }, duration: 0.5 });
			});

			element.addEventListener("click", (e) => {
				toggleControl();
			});
		});
	});
};

export default PromoReel;
